import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Tooltip from "react-bootstrap/lib/Tooltip";
import i18n from "../i18n/translate";
import SidebarMenuItem from './SidebarMenuItem';
import Icon from './Icon';
import { KebabCase } from '../util/StringUtil';
import url from 'url';

export default class SidebarMenuGroup extends React.Component {

  static propTypes = {
    currentUrl: PropTypes.string.isRequired,
    item: PropTypes.shape({
      icon: PropTypes.string,
      font_family: PropTypes.string,
      id: PropTypes.string,
      showChildren: PropTypes.bool,
      submenu_items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        target_url: PropTypes.string.isRequired
      })),
      target_url: PropTypes.string,
      title: PropTypes.string.isRequired
    }),
    onSelect: PropTypes.func.isRequired,
    setCurrentUrl: PropTypes.func.isRequired,
    serverSide: PropTypes.bool,
    sidebarExpanded: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  getValidQueryString = queryString => {
    const queryParams = queryString.replace('?', '').split('&');
    const newSearch = '?' + queryParams.reduce((newQuery, param) => {
      const [ key ] = param.split('=');
      if (key !== 'force') {
        newQuery.push(param);
      }
      return newQuery
    }, []).join('&');

    return newSearch === '?' ? '' : newSearch;
  }

  getUrlPath = urlStr => {
    const urlObj = url.parse(urlStr);
    return urlObj?.pathname + (urlObj.search ? this.getValidQueryString(urlObj.search) : '');
  }

  isSelectedItem = item => {
    if (!item.target_url || !this.props.currentUrl) {
      return;
    }

    const currentUrlPath = this.getUrlPath(this.props.currentUrl);
    const targetUrlPath = this.getUrlPath(item.target_url);
    const isExactMatch = currentUrlPath === targetUrlPath;
    const isValidPath = targetUrlPath.split('/').filter(sub => sub).length > 1;

    // engage dashboard and my/all events specific
    const matchCondition = !(currentUrlPath.includes('dashboard') || currentUrlPath.includes('events'))  && currentUrlPath.includes(targetUrlPath);

    // consider locale presence in current url, external links and home pages
    return isExactMatch || (isValidPath && matchCondition);
  };

  hasSubmenuItems = () => this.props.item && this.props.item.submenu_items && this.props.item.submenu_items.length > 0;

  onSelect = () => {
    this.props.onSelect(this.props.item);
  }

  getClassName() {
    const {
      item,
      item: {
        showChildren,
        submenu_items
      }
    } = this.props;
    const containsSelectedItem = submenu_items && submenu_items.some(this.isSelectedItem);
    let className = ['navgroup'];
    if (this.isSelectedItem(item)) {
      className.push('selected');
    }
    if (containsSelectedItem) {
      className.push('contains-selected');
    }
    if (showChildren) {
      className.push('expanded');
    }
    return className;
  }

  render() {
    const {
      currentUrl,
      item: {
        id,
        submenu_items,
        target_url,
        title
      },
      setCurrentUrl,
      serverSide,
      sidebarExpanded
    } = this.props;
    if (!target_url && !this.hasSubmenuItems()) {
      return null;
    }
    const labelIcon = <Icon fontFamily={this.props.item.font_family} iconType={this.props.item.icon} />
    const chevronIcon = this.hasSubmenuItems() && <Icon iconType="chevron-right" additionalClasses="chevron" />;

    let tooltip = <Tooltip id="tooltip">{i18n.t(title)}</Tooltip>;
    const overlay = <OverlayTrigger placement="right" overlay={tooltip}>{labelIcon}</OverlayTrigger>;
    let className = this.getClassName();

    return (
      <div
        className={className.join(' ')}
        key={title}
        data-object-type="sidebar-navigation"
        data-object-action={`sidebar-${KebabCase(title)}-${this.hasSubmenuItems() ? 'expand' : 'select'}`}
      >
        <div id={id} className="navgroup-label" onClick={this.onSelect}>
          {chevronIcon} {sidebarExpanded ? labelIcon : overlay} {title}
        </div>
        {this.hasSubmenuItems() && (
          <ul className="navgroup-list">
            {submenu_items.map((subitem) =>
              <SidebarMenuItem
                item={subitem}
                key={subitem.title}
                serverSide={serverSide}
                currentUrl={currentUrl}
                onClickLink={setCurrentUrl}
                isSelected={this.isSelectedItem}
              />
            )}
          </ul>
        )}
      </div>
    );
  }
}
